export enum MOCChecklistType {
  PSSR = 'PSSR',
  PSI = 'Process Safety Information (PSI)',
  FRA = 'Further Risk Assessment',
  RS = 'MOC Risk Screening',
  FR = 'Functional Review',
  IS = 'ImportedStudy',
  ROOTMOC = 'MOC Action Items'
}
